import { render, staticRenderFns } from "./HeadBoard.vue?vue&type=template&id=31c89a78&scoped=true"
import script from "./HeadBoard.vue?vue&type=script&lang=js"
export * from "./HeadBoard.vue?vue&type=script&lang=js"
import style0 from "./HeadBoard.vue?vue&type=style&index=0&id=31c89a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c89a78",
  null
  
)

export default component.exports